import formCheckbox from '@/components/forms/checkbox/checkbox.vue';

export default {
  props: {
    validation: {
      type: Object,
      required: true,
    },
  },
  components: {
    formCheckbox,
  },
  computed: {
    hasOneUpperLower() {
      return !this.validation.hasOneLower.$invalid && !this.validation.hasOneUpper.$invalid;
    },
  },
};
